import { createFileRoute } from "@tanstack/react-router";
import { OnboardingLayout } from "@/components/onboarding/onboarding-layout";
import { ThemeForm } from "@/components/onboarding/theme-form";

export const Route = createFileRoute("/onboarding/tema")({
	component: OnboardingStep3,
});

function OnboardingStep3() {
	return (
		<OnboardingLayout>
			<ThemeForm />
		</OnboardingLayout>
	);
}
